(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["promotion-code-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('promotion-code-banner')) {
    customElements.define('promotion-code-banner', class extends HTMLElement {
      connectedCallback() {
        this.copyButton = this.querySelector('[data-promotion-copy]');
        this.copyLabel = this.querySelector('[data-promotion-copy-label]');
        this.status = this.querySelector('[data-promotion-status]');

        if (this.copyButton) {
          this.copyButton.addEventListener('click', () => this.copyCode());
        }
      }

      async copyCode() {
        const code = this.dataset.promotionCode;
        let copied = false;

        if (navigator.clipboard && window.isSecureContext) {
          try {
            await navigator.clipboard.writeText(code);
            copied = true;
          } catch (error) {
            copied = false;
          }
        }

        if (!copied) {
          const input = document.createElement('textarea');
          input.value = code;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          copied = document.execCommand('copy');
          input.remove();
        }

        if (copied) {
          const originalLabel = this.copyLabel.textContent;
          const copiedLabel = this.copyButton.dataset.copiedLabel;
          this.copyLabel.textContent = copiedLabel;
          this.status.textContent = copiedLabel;
          window.clearTimeout(this.resetTimer);
          this.resetTimer = window.setTimeout(() => {
            this.copyLabel.textContent = originalLabel;
            this.status.textContent = '';
          }, 1800);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
